import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en-US',
  interpolation: {
    escapeValue: false
  },
  resources: {
    'en-US': {
      translation: {
        Asof: 'As of',
        DownloadData: 'Download Data',
        WisdomTree: 'WisdomTree',
        Ticker: 'Ticker',
        Fund: 'Fund',
        Website: 'Website',
        Filings: 'Filings',
        InceptionDate: 'Inception Date',
        ManagementStyle: 'Management Style',
        Name: 'Name',
        SharesOutstanding: 'Shares Outstanding',
        AssetsUnder: 'Assets Under',
        Trailing: 'Trailing 12',
        Yield: 'Month Yield',
        AUM: 'All AUM',
        NAV: 'NAV',
        IndexTicker: 'Index Ticker',
        Index: 'Index',
        thousands: 'Mgmt $(000)',
        htmlbreak: '   ',
        SEARCH: 'SEARCH BY TICKER OR NAME',
        AllProductTypes: 'All Product Types',
        AllManagementStyles: 'Any Management Style',
        AllStructure: 'All Structures',
        AllAssetClasses: 'Any Asset Class',
        AllSubAssetClasses: 'Any Sub-Asset Class',
        IndustrySubGroups: 'Any Industry Sub Group',
        LeverageFactor: 'Any Leverage Factor',
        AllRegions: 'Any Region',
        AllCountries: 'Any Country',
        UseOfIncome: 'Use Of Income',
        Products: 'Products',
        Product: 'Product',
        MER: 'MER',
        Base: 'Base',
        Trading: 'Trading',
        Currency: 'Currency',
        UseOf: 'Use of',
        Income: 'Income',
        Exchange: 'Exchange',
        Code: 'Code',
        Leverage: 'Leverage',
        Factor: 'Factor',
        Price: 'Price',
        Daily: 'Daily',
        Change: 'Change',
        Factsheet: 'Factsheet',
        Unleveraged: 'Unleveraged',
        ShortAndLeveraged: 'Short and Leveraged',
        FundTicker: 'Fund Ticker',
        documents: 'Documents & Details',
        funds: 'Funds',
        kid: 'KID/KIID',
        responsibleInvesting: 'Responsible Investing',
        aumplaceholder: 'Any AUM',
        expenseplaceholder: 'Any Net Expense Ratio',
        volumeplaceholder: 'Any Volume',
        inceptionplaceholder: 'Any Since Inception',
        mstarplaceholder: 'Any Morningstar Rating',
        ttmyieldplaceholder: 'Any Trailing 12 Month Yield',
        volume: 'Volume',
        perf: 'Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor’s shares, when redeemed, may be worth more or less than their original cost.',
        tickerClick: 'Click on the respective fund ticker in the table above to view a fund’s specific standardized and month-end performance, in addition to the fund’s 30-day SEC yield.',
        grossexpense: ' Gross Expense',
        netexpense: 'Net Expense ',
        ttmyield: '12-Month Yield: The percentage of dividends paid over the last 12 months as a proportion of the fund’s current net asset value (NAV).'
      }
    },
    'en-GB': {
      translation: {
        Asof: 'As of',
        DownloadData: 'Download Data',
        WisdomTree: 'WisdomTree',
        Ticker: 'Ticker',
        Fund: 'Fund',
        Website: 'Website',
        Filings: 'Filings',
        InceptionDate: 'Inception Date',
        ManagementStyle: 'Management Style',
        Name: 'Name',
        SharesOutstanding: 'Shares Outstanding',
        AssetsUnder: 'Assets Under',
        AUM: 'Total Assets Under Management',
        NAV: 'NAV',
        IndexTicker: 'Index Ticker',
        Index: 'Index',
        thousands: 'Mgmt $(000)',
        htmlbreak: '   ',
        SEARCH: 'SEARCH BY TICKER, NAME OR CATEGORIES ',
        AllProductTypes: 'All Product Types',
        AllManagementStyles: 'All Management Styles',
        AllStructure: 'All Structures',
        AllAssetClasses: 'All Asset Classes',
        AllSubAssetClasses: 'All Sub-Asset Classes',
        IndustrySubGroups: 'All Industry Sub Groups',
        LeverageFactor: 'All Leverage Factors',
        AllRegions: 'All Regions',
        AllCountries: 'All Countries',
        UseOfIncome: 'Use Of Income',
        Products: 'Products',
        Product: 'Product',
        MER: 'Management Expense Ratio',
        Base: 'Base',
        Trading: 'Trading',
        Currency: 'Currency',
        UseOf: 'Use of',
        Income: 'Income',
        Exchange: 'Exchange',
        Code: 'Code',
        Leverage: 'Leverage',
        Factor: 'Factor',
        Price: 'Price',
        Daily: 'Daily',
        Change: 'Change',
        Factsheet: 'Factsheet',
        Unleveraged: 'Unleveraged',
        ShortAndLeveraged: 'Short and Leveraged',
        FundTicker: 'Fund Ticker',
        documents: 'Documents',
        funds: 'Key Information',
        kid: 'KID/KIID',
        responsibleInvesting: 'Responsible Investing',
        aumplaceholder: 'Any AUM',
        expenseplaceholder: 'Any Expense Ratio',
        volumeplaceholder: 'Any Volume',
        inceptionplaceholder: 'Any Since Inception',
        mstarplaceholder: 'Any Morningstar Rating',
        ttmyieldplaceholder: 'Any Trailing 12 Month Yield',
        volume: 'Volume',
        yield: 'Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor’s shares, when redeemed, may be worth more or less than their original cost.',
        tickerClick: 'Click on the respective fund ticker in the table above to view a fund’s specific standardized and month-end performance, in addition to the fund’s 30-day SEC yield'
      }
    },
    'it-IT': {
      translation: {
        Asof: 'Al',
        DownloadData: 'Scarica Dati',
        WisdomTree: 'WisdomTree',
        Ticker: 'Codice di Borsa',
        Fund: 'Fondo',
        Website: 'Sito web',
        Filings: 'limatura',
        InceptionDate: 'Data di inizio',
        ManagementStyle: 'Stile di gestione',
        Name: 'Nome',
        SharesOutstanding: 'Azioni in circolazione',
        AssetsUnder: 'Assets Under',
        AUM: 'Patrimonio in gestione',
        NAV: 'NAV',
        IndexTicker: 'Index Ticker',
        Index: 'Index',
        thousands: 'Mgmt $(000)',
        htmlbreak: '   ',
        SEARCH: 'RICERCA PER TICKER, NOME O CATEGORIE',
        AllStructure: 'Struttura',
        AllProductTypes: 'Tutti i prodotti',
        AllManagementStyles: 'Tutta la struttura',
        AllAssetClasses: 'Tutte le classi di attività',
        AllSubAssetClasses: 'Tutte le classi di attività secondarie',
        IndustrySubGroups: 'Sottogruppi di settore',
        LeverageFactor: 'Fattore leva',
        AllRegions: 'Tutte le regioni',
        AllCountries: 'Tutti i paesi',
        UseOfIncome: 'Utilizzo delle entrate',
        Products: 'Prodotti',
        Product: 'Prodotto',
        MER: 'Management Expense Ratio',
        Base: 'Valuta di base',
        Trading: 'Valuta di negoziazione',
        Currency: '',
        UseOf: 'Utilizzo delle',
        Income: 'entrate',
        Exchange: 'Exchange',
        Code: 'Code',
        Leverage: 'Fattore',
        Factor: 'leva',
        Price: 'NAV',
        Daily: 'Performance ',
        Change: 'giornaliera',
        Factsheet: 'Documento informativo',
        Unleveraged: 'Delta-1',
        ShortAndLeveraged: 'Short e con leva',
        documents: 'Documenti',
        funds: 'Informazione',
        kid: 'KID/KIID',
        responsibleInvesting: 'Responsible Investing',
        aumplaceholder: 'Any AUM',
        expenseplaceholder: 'Any Expense Ratio',
        volumeplaceholder: 'Any Volume',
        inceptionplaceholder: 'Any Since Inception',
        mstarplaceholder: 'Any Morningstar Rating',
        ttmyieldplaceholder: 'Any Trailing 12 Month Yield',
        volume: 'Volume',
        yield: 'Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor’s shares, when redeemed, may be worth more or less than their original cost.',
        tickerClick: 'Click on the respective fund ticker in the table above to view a fund’s specific standardized and month-end performance, in addition to the fund’s 30-day SEC yield'
      }
    },
    'it-CH': {
      translation: {
        Asof: 'Al',
        DownloadData: 'Scarica Dati',
        WisdomTree: 'WisdomTree',
        Ticker: 'Codice di Borsa',
        Fund: 'Fondo',
        Website: 'Sito web',
        Filings: 'limatura',
        InceptionDate: 'Data di inizio',
        ManagementStyle: 'Stile di gestione',
        Name: 'Nome',
        SharesOutstanding: 'Azioni in circolazione',
        AssetsUnder: 'Assets Under',
        AUM: 'Patrimonio in gestione',
        NAV: 'NAV',
        IndexTicker: 'Index Ticker',
        Index: 'Index',
        thousands: 'Mgmt $(000)',
        htmlbreak: '   ',
        SEARCH: 'RICERCA PER TICKER, NOME O CATEGORIE',
        AllStructure: 'Struttura',
        AllProductTypes: 'Tutti i prodotti',
        AllManagementStyles: 'Tutta la struttura',
        AllAssetClasses: 'Tutte le classi di attività',
        AllSubAssetClasses: 'Tutte le classi di attività secondarie',
        IndustrySubGroups: 'Sottogruppi di settore',
        LeverageFactor: 'Fattore leva',
        AllRegions: 'Tutte le regioni',
        AllCountries: 'Tutti i paesi',
        UseOfIncome: 'Utilizzo delle entrate',
        Products: 'Prodotti',
        Product: 'Prodotto',
        MER: 'Management Expense Ratio',
        Base: 'Valuta di base',
        Trading: 'Valuta di negoziazione',
        Currency: '',
        UseOf: 'Utilizzo delle',
        Income: 'entrate',
        Exchange: 'Exchange',
        Code: 'Code',
        Leverage: 'Fattore',
        Factor: 'leva',
        Price: 'NAV',
        Daily: 'Performance ',
        Change: 'giornaliera',
        Factsheet: 'Documento informativo',
        Unleveraged: 'Delta-1',
        ShortAndLeveraged: 'Short e con leva',
        documents: 'Documenti',
        funds: 'Informazione',
        kid: 'KID/KIID',
        responsibleInvesting: 'Responsible Investing',
        aumplaceholder: 'Any AUM',
        expenseplaceholder: 'Any Expense Ratio',
        volumeplaceholder: 'Any Volume',
        inceptionplaceholder: 'Any Since Inception',
        mstarplaceholder: 'Any Morningstar Rating',
        ttmyieldplaceholder: 'Any Trailing 12 Month Yield',
        volume: 'Volume',
        yield: 'Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor’s shares, when redeemed, may be worth more or less than their original cost.',
        tickerClick: 'Click on the respective fund ticker in the table above to view a fund’s specific standardized and month-end performance, in addition to the fund’s 30-day SEC yield'
      }
    },
    'de-DE': {
      translation: {
        Asof: 'Stand',
        DownloadData: 'Daten Herunterladen',
        WisdomTree: 'WisdomTree',
        Ticker: 'Börsencode',
        Fund: 'Fonds',
        Website: 'Webseite',
        Filings: 'Einreichungen',
        InceptionDate: 'Anfangszeitpunkt',
        ManagementStyle: 'Führungsstil',
        Name: 'Name',
        SharesOutstanding: 'Aktien ausstehend',
        AssetsUnder: 'Vermögenswerte unter',
        AUM: 'Produkt AUM',
        NAV: 'NAV',
        IndexTicker: 'Index Ticker',
        Index: 'Index',
        thousands: 'Mgmt $(000)',
        htmlbreak: '   ',
        SEARCH: 'SUCHE NACH TICKER, NAME ODER KATEGORIEN',
        AllStructure: 'Struktur',
        AllProductTypes: 'Produktart',
        AllManagementStyles: 'Alle Managementstile',
        AllAssetClasses: 'Alle Anlageklassen',
        AllSubAssetClasses: 'Alle Unteranlageklassen',
        IndustrySubGroups: 'Untergruppen der Branche',
        LeverageFactor: 'Hebelfaktor',
        AllRegions: 'Regionen',
        AllCountries: 'Alle Länder',
        UseOfIncome: 'Einkommensverwendung',
        Products: 'Produktangaben',
        Product: 'Produkt',
        MER: 'Management Expense Ratio',
        Base: 'Basiswährung',
        Trading: 'Währung (Handel)',
        Currency: '',
        UseOf: 'Einkommensverwendung',
        Income: '',
        Exchange: 'Austausch',
        Code: 'Code',
        Leverage: 'Hebelfaktor',
        Factor: '',
        Price: 'NAV',
        Daily: 'Tägl.Rendite',
        Change: '',
        Factsheet: 'Documento informativo',
        Unleveraged: 'Delta-1',
        ShortAndLeveraged: 'Short-Leveraged',
        documents: 'Dokumente',
        funds: 'Produktart',
        kid: 'KID/KIID',
        responsibleInvesting: 'Responsible Investing',
        aumplaceholder: 'Any AUM',
        expenseplaceholder: 'Any Expense Ratio',
        volumeplaceholder: 'Any Volume',
        inceptionplaceholder: 'Any Since Inception',
        mstarplaceholder: 'Any Morningstar Rating',
        ttmyieldplaceholder: 'Any Trailing 12 Month Yield',
        volume: 'Volume',
        yield: 'Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor’s shares, when redeemed, may be worth more or less than their original cost.',
        tickerClick: 'Click on the respective fund ticker in the table above to view a fund’s specific standardized and month-end performance, in addition to the fund’s 30-day SEC yield'
      }
    },
    'de-AT': {
      translation: {
        Asof: 'Stand',
        DownloadData: 'Daten Herunterladen',
        WisdomTree: 'WisdomTree',
        Ticker: 'Börsencode',
        Fund: 'Fonds',
        Website: 'Webseite',
        Filings: 'Einreichungen',
        InceptionDate: 'Anfangszeitpunkt',
        ManagementStyle: 'Führungsstil',
        Name: 'Name',
        SharesOutstanding: 'Aktien ausstehend',
        AssetsUnder: 'Vermögenswerte unter',
        AUM: 'Produkt AUM',
        NAV: 'NAV',
        IndexTicker: 'Index Ticker',
        Index: 'Index',
        thousands: 'Mgmt $(000)',
        htmlbreak: '   ',
        SEARCH: 'SUCHE NACH TICKER, NAME ODER KATEGORIEN',
        AllStructure: 'Struktur',
        AllProductTypes: 'Produktart',
        AllManagementStyles: 'Alle Managementstile',
        AllAssetClasses: 'Alle Anlageklassen',
        AllSubAssetClasses: 'Alle Unteranlageklassen',
        IndustrySubGroups: 'Untergruppen der Branche',
        LeverageFactor: 'Hebelfaktor',
        AllRegions: 'Regionen',
        AllCountries: 'Alle Länder',
        UseOfIncome: 'Einkommensverwendung',
        Products: 'Produktangaben',
        Product: 'Produkt',
        MER: 'Management Expense Ratio',
        Base: 'Basiswährung',
        Trading: 'Währung (Handel)',
        Currency: '',
        UseOf: 'Einkommensverwendung',
        Income: '',
        Exchange: 'Austausch',
        Code: 'Code',
        Leverage: 'Hebelfaktor',
        Factor: '',
        Price: 'NAV',
        Daily: 'Tägl.Rendite',
        Change: '',
        Factsheet: 'Documento informativo',
        Unleveraged: 'Delta-1',
        ShortAndLeveraged: 'Short-Leveraged',
        documents: 'Dokumente',
        funds: 'Produktart',
        kid: 'KID/KIID',
        responsibleInvesting: 'Responsible Investing',
        aumplaceholder: 'Any AUM',
        expenseplaceholder: 'Any Expense Ratio',
        volumeplaceholder: 'Any Volume',
        inceptionplaceholder: 'Any Since Inception',
        mstarplaceholder: 'Any Morningstar Rating',
        ttmyieldplaceholder: 'Any Trailing 12 Month Yield',
        volume: 'Volume',
        yield: 'Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor’s shares, when redeemed, may be worth more or less than their original cost.',
        tickerClick: 'Click on the respective fund ticker in the table above to view a fund’s specific standardized and month-end performance, in addition to the fund’s 30-day SEC yield'

      }
    },
    'de-CH': {
      translation: {
        Asof: 'Stand',
        DownloadData: 'Daten Herunterladen',
        WisdomTree: 'WisdomTree',
        Ticker: 'Börsencode',
        Fund: 'Fonds',
        Website: 'Webseite',
        Filings: 'Einreichungen',
        InceptionDate: 'Anfangszeitpunkt',
        ManagementStyle: 'Führungsstil',
        Name: 'Name',
        SharesOutstanding: 'Aktien ausstehend',
        AssetsUnder: 'Vermögenswerte unter',
        AUM: 'Produkt AUM',
        NAV: 'NAV',
        IndexTicker: 'Index Ticker',
        Index: 'Index',
        thousands: 'Mgmt $(000)',
        htmlbreak: '   ',
        SEARCH: 'SUCHE NACH TICKER, NAME ODER KATEGORIEN',
        AllStructure: 'Struktur',
        AllProductTypes: 'Produktart',
        AllManagementStyles: 'Alle Managementstile',
        AllAssetClasses: 'Alle Anlageklassen',
        AllSubAssetClasses: 'Alle Unteranlageklassen',
        IndustrySubGroups: 'Untergruppen der Branche',
        LeverageFactor: 'Hebelfaktor',
        AllRegions: 'Regionen',
        AllCountries: 'Alle Länder',
        UseOfIncome: 'Einkommensverwendung',
        Products: 'Produktangaben',
        Product: 'Produkt',
        MER: 'Management Expense Ratio',
        Base: 'Basiswährung',
        Trading: 'Währung (Handel)',
        Currency: '',
        UseOf: 'Einkommensverwendung',
        Income: '',
        Exchange: 'Austausch',
        Code: 'Code',
        Leverage: 'Hebelfaktor',
        Factor: '',
        Price: 'NAV',
        Daily: 'Tägl.Rendite',
        Change: '',
        Factsheet: 'Documento informativo',
        Unleveraged: 'Delta-1',
        ShortAndLeveraged: 'Short-Leveraged',
        documents: 'Dokumente',
        funds: 'Produktart',
        kid: 'KID/KIID',
        responsibleInvesting: 'Responsible Investing',
        aumplaceholder: 'Any AUM',
        expenseplaceholder: 'Any Expense Ratio',
        volumeplaceholder: 'Any Volume',
        inceptionplaceholder: 'Any Since Inception',
        mstarplaceholder: 'Any Morningstar Rating',
        ttmyieldplaceholder: 'Any Trailing 12 Month Yield',
        volume: 'Volume',
        yield: 'Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor’s shares, when redeemed, may be worth more or less than their original cost.',
        tickerClick: 'Click on the respective fund ticker in the table above to view a fund’s specific standardized and month-end performance, in addition to the fund’s 30-day SEC yield'
      }
    }
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js